import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsPedido from '../../../actions/pedido';
import * as actionsMain from '../../../actions/main';

import getPedidos from '../../../graphql/querys/ventas/getPedidos.graphql';
import deletePedido from '../../../graphql/mutations/venta/deletePedido.graphql';
import archivarPedido from '../../../graphql/mutations/venta/archivarPedido.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import TablaPedidos from './TablaPedidos';
const confirm = Modal.confirm;

@compose(
  graphql(getPedidos, { options: { fetchPolicy: 'network-only' } }),
  graphql(getOrganismos, { name: 'organismos' }),
  graphql(deletePedido, {
    name: 'deletePedido',
    options: {
      refetchQueries: [{ query: getPedidos }],
    },
  }),
  graphql(archivarPedido, {
    name: 'archivarPedido',
    options: {
      refetchQueries: [{ query: getPedidos }],
    },
  })
)
class VerPedidos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      currentPage: 1,
      listaTotal: [],
      lista: [],
      filtro: [],
      fechaInicial: moment().subtract(7, 'd'),
      fechaFinal: moment(),
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete = id_ingreso => {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este pedido?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deletePedido({
            variables: { _id: id_ingreso },
          })
          .then(res => {
            let id = res.data.deletePedido;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);
              notification.warning({
                message: 'Pedido eliminado',
                description: 'Se ha eliminado el pedido exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el pedido');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion del pedido',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  archivarPedido = _id => {
    // console.log('ENTRE: ', this.props);
    this.props
      .archivarPedido({
        variables: {
          _id: _id,
        },
      })
      .then(respuesta => {
        console.log('Archivar respuesta: ', respuesta);
        if (respuesta.data.archivarPedido) {
          notification.info({
            message: 'Pedido archivado',
            description: 'Se ha cambiado el estado del pedido exitosamente',
          });
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de archivar el pedido');
        console.log(err);

        Modal.error({
          title: 'Error a la hora de archivar del pedido',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    if (this.props.data.getPedidos) {
      this.setState({
        ...this.state,
        loading: true,
      });

      let listaFiltrada = this.props.data.getPedidos;

      if (this.state.fechaInicial && this.state.fechaFinal) {
        listaFiltrada = _.filter(listaFiltrada, pedido => {
          return (
            pedido.fechaPedido > this.state.fechaInicial.toDate().getTime() &&
            pedido.fechaPedido < this.state.fechaFinal.toDate().getTime()
          );
        });
      }
      if (this.state.filtro.length > 0) {
        listaFiltrada = _.filter(listaFiltrada, pedido => {
          return _.indexOf(this.state.filtro, pedido.estado) >= 0;
        });
      }

      this.setState(
        {
          ...this.state,
          loading: false,
          listaTotal: listaFiltrada,
        },
        function() {
          this.ordenarLista(1, 5);
        }
      );
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.getPedidos) {
      // console.log('ENTRE CON ....', nextProps.data.getPedidos);
      this.setState(
        {
          ...this.state,
          listaTotal: nextProps.data.getPedidos,
        },
        function() {
          this._executeSearch();
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    // console.log('VOY A ORDENAR LA LISTA: ', this.state);
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        ingreso => {
          return ingreso.numero;
        },
      ],
      ['desc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
      listaTotal: listaOrdenada,
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChangeFechas = (date, dateString) => {
    // console.log(date);
    // console.log(dateString);
    this.setState(
      {
        ...this.state,
        fechaInicial: date[0] ? date[0] : '',
        fechaFinal: date[1] ? date[1] : '',
      },
      () => {
        this._executeSearch();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  handleTableChange = (pagination, filters, sorter) => {
    // console.log('RECIBO: ');
    // console.log(pagination, filters, sorter);

    this.setState(
      {
        filtro: filters.estado,
      },
      () => {
        this._executeSearch();
      }
    );
  };

  generarEnvio = pedido => {
    // console.log('Me LLEGA!!!!: ', pedido);
    // console.log('props: ', this.props);
    this.props.actionsPedido.setPedido(pedido);
    this.props.history.push('/administracionGeneral/ingresos/nuevo');
  };

  render() {
    if (this.state.loading || this.props.data.loading) {
      return <Loading />;
    }

    const { usuario } = this.props;

    return (
      <TablaPedidos
        usuario={usuario}
        data={this.state.listaTotal}
        onChange={this.onChangeFechas}
        cambiarOrganismo={this.cambiarOrganismo}
        archivarPedido={this.archivarPedido}
        handleTableChange={this.handleTableChange}
        generarEnvio={this.generarEnvio}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPedido: bindActionCreators(actionsPedido, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerPedidos));
